import $ from "jquery";

export const init = () => {
  // Main Navigation Sticky -----------------------------------------------------
  let intialtop = $(document).scrollTop();
  let headerheight = $("body .page-header").outerHeight();
  let fixed = true;

  $(window).on("scroll", function () {
    let afterscrolltop = $(document).scrollTop();
    let navVisible = $(".nav-container-open").length;
    let pageHeader = $("body:not(.flyout-header) .page-header");
    let flyPageHeader = $("body.flyout-header .page-header");

    flyPageHeader.addClass("fixed");

    if (navVisible === 0) {
      // afterscrolltop > headerheight ? $(".page-header").addClass("navhide") : $(".page-header").removeClass("navhide");
      if (afterscrolltop > headerheight) {
        pageHeader.addClass("navhide");
        flyPageHeader.addClass("navhide");
      } else {
        pageHeader.removeClass("navhide");
        flyPageHeader.removeClass("navhide");
      }

      // afterscrolltop > intialtop ? $(".page-header").removeClass("fixed") :
      if (afterscrolltop > intialtop) {
        pageHeader.removeClass("fixed");
        // flyPageHeader.removeClass("fixed");
      } else {
        pageHeader.addClass("fixed");
        flyPageHeader.addClass("fixed");
      }

      // Beim nach oben Scrollen: fixed Header nur einblenden, wenn eine größere Distanz zurückgelegt wurde
      if (afterscrolltop > intialtop) {
        pageHeader.removeClass("fixed");
        // flyPageHeader.removeClass("fixed");
      } else {
        if (intialtop - afterscrolltop > 10) {
          pageHeader.addClass("fixed");
          flyPageHeader.addClass("fixed");
        }
      }

      // Version 2 bei Sprungmarkenmenü (siehe auch Zeile 390)
      if (fixed === false) {
        pageHeader.removeClass("fixed");
        // flyPageHeader.removeClass("fixed");
      }
      intialtop = $(document).scrollTop();

      let half_height = $(window).height() / 2;

      // $(this).scrollTop() > half_height ? $(".backtotop").fadeIn() : $(".backtotop").fadeOut();
      if ($(this).scrollTop() > half_height) {
        $(".backtotop").fadeIn();
      } else {
        $(".backtotop").fadeOut();
      }
    }
  });
};
